export function resetPreSelectedFilters() {
    console.log('resetPreSelectedFilters');
    localStorage.removeItem('selectedFilters');
    localStorage.removeItem('filterCategoryName');
    localStorage.removeItem('sortBy');
}